import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { FormulaireService } from "../../core/service/formulaire.service";
import { Formulaire } from "../../core/model/formulaire";

@Component({
  selector: "app-edit-formulaire",
  templateUrl: "./edit-formulaire.component.html",
  styleUrls: ["./edit-formulaire.component.scss"],
})
export class EditFormulaireComponent implements OnInit {
  @Input()
  set formulaire(value: Formulaire) {
    if (value) {
      this._formulaire = { ...value };
      this.cdr.detectChanges();
    }
  }
  get formulaire(): Formulaire {
    return this._formulaire;
  }

  private _formulaire: Formulaire;

  form2: FormGroup;
  pressButton: Boolean = false;
  loading = false;

  constructor(
    private _formulaireService: FormulaireService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      lien: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  save(): void {
    this.pressButton = true;
    this._formulaireService
      .update(this.formulaire)
      .pipe(first())
      .subscribe(
        () => {
          this.pressButton = false;
          this.activeModal.close(this.formulaire);
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
